<template>
    <el-dialog :visible.sync="show" width="30%" :append-to-body="true"  class="h5PlanIframe">
        <iframe frameborder="0" noresize="noresize" :style="'width: 100%;height:80vh;margin-top: 0.3rem;'"
                :src="src"
        ></iframe>
    </el-dialog>
</template>

<script>
export default {
    name: "H5PlanIframe",
    data() {
         return {
             show: false,
             src: ''
         }
    },
    computed: {
        // getSrc() {
        //     return function () {
        //         return `https://www.test.register.dijie360.com/Collection?programmeId=63&type=1&budgetMainId=${this.budgetMainId}&planId=${this.planId}&priceDisplay=%7B%22programme%22%3A%7B%22checkProgrammeItems%22%3A%5B4%2C5%2C6%2C7%2C8%2C0%2C1%2C2%2C3%5D%7D%2C%22offer%22%3A%7B%22checkOfferItems%22%3A%5B0%2C1%2C2%5D%7D%7D`
        //     }
        // }
    },
    methods: {
        open(src) {
            this.src = src
            this.show = true
        }
    }
}
</script>

<style lang="scss" scoped>
.h5PlanIframe {
    z-index: 9999 !important;
    /deep/ .el-dialog {
        left: -15vw;
    }
}

</style>
